import { render } from "./OlvidoClave.vue?vue&type=template&id=6235dc1e&scoped=true"
import script from "./OlvidoClave.vue?vue&type=script&lang=js"
export * from "./OlvidoClave.vue?vue&type=script&lang=js"

import "./OlvidoClave.vue?vue&type=style&index=0&id=6235dc1e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6235dc1e"]])

export default __exports__